import { Link } from "react-router-dom";
import {
  ArrowLeftIcon,
  Bars3Icon,
  HomeIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { ROUTES } from "@/domain/constants/routes";

interface ConversationNavbarProps {
  onMenuClick: () => void;
}

/**
 * 對話頁面導航欄
 * 顯示 Logo、助手資訊和選單按鈕
 * 完全匹配 chat.html 的樣式和功能
 */
export function ConversationNavbar({ onMenuClick }: ConversationNavbarProps) {
  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-earth-green/10 sticky top-0 z-50 safe-area-top">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-6 py-2 md:py-3">
        {/* Logo */}
        <div className="flex items-center space-x-2 md:space-x-3">
          <img
            src="/assets/images/logo.png"
            alt="麻薏 Mayi AI Logo"
            className="w-8 h-8 md:w-10 md:h-10"
          />
          <div>
            <span className="text-xl md:text-lg font-semibold text-earth-green font-serif-tc">
              麻薏 Mayi AI
            </span>
            <div className="text-xs md:text-sm text-tea-brown hidden md:block">
              智慧營運助手平台
            </div>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          {/* <div className="flex items-center space-x-1 text-sm text-tea-brown">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
            <span>12 種專業助手可用</span>
          </div> */}

          {/* 返回列表按鈕 */}
          <Link
            to={ROUTES.LIST}
            className="text-tea-brown hover:text-earth-green transition-colors flex items-center"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            <span>返回列表</span>
          </Link>
          <Link
            to={ROUTES.HOME}
            className="text-tea-brown hover:text-earth-green transition-colors flex items-center"
          >
            <HomeIcon className="w-4 h-4 mr-2" />
            <span>首頁</span>
          </Link>
          <button
            onClick={onMenuClick}
            className="text-tea-brown hover:text-earth-green transition-colors flex items-center"
          >
            <Cog6ToothIcon className="w-4 h-4 mr-2" />
            <span>設定</span>
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={onMenuClick}
          className="md:hidden touch-button flex items-center justify-center w-8 h-8 text-tea-brown"
        >
          <Bars3Icon className="w-5 h-5 min-w-5 min-h-5" />
        </button>
      </div>
    </header>
  );
}
